import { AuthorizationStatusEnum } from "@/app/services/authorizationService/getAuthorization";
import { OptionType } from "@/app/utils/optionSelectType";
import { PartnerType } from "@/app/utils/partners.enum";
import { StatusEnum, statusLabels } from "@/app/utils/status";

export const authorizationStatusMap: Record<
  AuthorizationStatusEnum,
  StatusEnum
> = {
  [AuthorizationStatusEnum.PENDING]: StatusEnum.PENDING,
  [AuthorizationStatusEnum.AUTHORIZED]: StatusEnum.ACTION_REQUIRED,
  [AuthorizationStatusEnum.NO_OFFER]: StatusEnum.REFUSED,
  [AuthorizationStatusEnum.COMPLETED]: StatusEnum.FINALIZED,
};

export const authorizationStatusOptions: OptionType[] = (
  Object.keys(authorizationStatusMap) as AuthorizationStatusEnum[]
).map((status) => ({
  value: status,
  label: statusLabels[authorizationStatusMap[status]],
}));

export const authorizationProductTypes: PartnerType[] = [
  PartnerType.C6,
  PartnerType.PAN,
  PartnerType.CREFAZ_CLT,
];
